var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { SvgIcon as Svg } from 'ha/ui/SvgIcon';

const SvgGraduate = props => /*#__PURE__*/React.createElement(Svg, _extends({
  width: 18,
  height: 18,
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.84 4.582L1.125 7.65l7.757 2.738c.25.088.524.088.774 0l7.025-2.48a.29.29 0 00.01-.544L9.699 4.582a1.163 1.163 0 00-.858 0zM1.125 7.65v4.262",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.615 8.887v3.665a.871.871 0 00.55.814l3.78 1.396c.208.084.44.084.649 0l3.78-1.396a.872.872 0 00.549-.814V8.887",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

export default SvgGraduate;